import {
  LINK_KEY_ACCESSORIES,
  LINK_KEY_COMPARE,
  LINK_KEY_FEATURES,
  LINK_KEY_OVERVIEW,
  LINK_KEY_PHOTOS,
  LINK_KEY_PRICING,
  LINK_KEY_PROMO,
  LINK_KEY_RESEARCH,
  LINK_KEY_REVIEWS,
  LINK_KEY_SIMILAR,
  LINK_KEY_SPECS,
} from './constants';
import type { NavLinkConfigList } from './types';

export const navLinkConfigList: NavLinkConfigList = [
  {
    key: LINK_KEY_OVERVIEW,
    text: 'Overview',
    href: '',
  },
  {
    key: LINK_KEY_PRICING,
    text: 'Pricing',
    href: '/pricing',
  },
  {
    key: LINK_KEY_PHOTOS,
    text: 'Photos',
    href: '/photos',
  },
  {
    key: LINK_KEY_RESEARCH,
    text: 'Research',
    href: '/research',
  },
  {
    key: LINK_KEY_REVIEWS,
    text: 'Reviews',
    href: '/reviews',
  },
  {
    key: LINK_KEY_SPECS,
    text: 'Specs',
    href: '/specs',
    allowAppendSubModelId: true,
  },
  {
    key: LINK_KEY_FEATURES,
    text: 'Features',
    href: '/features',
    allowAppendSubModelId: true,
  },
  {
    key: LINK_KEY_SIMILAR,
    text: 'Similar',
    href: '/similar',
  },
  {
    key: LINK_KEY_ACCESSORIES,
    text: 'Accessories',
    href: '/accessories',
  },
  {
    key: LINK_KEY_PROMO,
    text: 'Promo',
    href: '/promo',
  },
];

export const mobileNavLinkConfigList: NavLinkConfigList = [
  {
    key: LINK_KEY_OVERVIEW,
    text: 'Overview',
    href: '',
  },
  {
    key: LINK_KEY_PHOTOS,
    text: 'Photos',
    href: '/photos',
  },
  {
    key: LINK_KEY_REVIEWS,
    text: 'Reviews',
    href: '/reviews',
  },
  {
    key: LINK_KEY_PROMO,
    text: 'Promo',
    href: '/promo',
  },
  {
    key: LINK_KEY_COMPARE,
    text: 'Compare',
    href: '/compare',
  },
];

export const upcomingModelsNavLinkConfigList: NavLinkConfigList = [
  {
    key: LINK_KEY_OVERVIEW,
    text: 'Overview',
    href: '',
  },
  {
    key: LINK_KEY_PRICING,
    text: 'Pricing',
    href: '/pricing',
    disabled: true,
  },
  {
    key: LINK_KEY_PHOTOS,
    text: 'Photos',
    href: '/photos',
  },
  {
    key: LINK_KEY_RESEARCH,
    text: 'Research',
    href: '/research',
  },
  {
    key: LINK_KEY_REVIEWS,
    text: 'Reviews',
    href: '/reviews',
  },
  {
    key: LINK_KEY_SIMILAR,
    text: 'Similar',
    href: '/similar',
    disabled: true,
  },
  {
    key: LINK_KEY_ACCESSORIES,
    text: 'Accessories',
    href: '/accessories',
  },
  {
    key: LINK_KEY_PROMO,
    text: 'Promo',
    href: '/promo',
    disabled: true,
  },
];
